import { Box } from "@mui/material";
import React from "react";

const Transition = ({
  children,
  showTranslate,
}: {
  children: React.ReactElement | React.ReactElement[];
  showTranslate: boolean;
}) => {
  const filteredChildren = React.Children.toArray(children).filter(
    (child: any) => {
      if (child.type === Transition.Default && !showTranslate) {
        return true;
      }
      if (child.type === Transition.Translate && showTranslate) {
        return true;
      }
      return false;
    }
  );
  return <Box>{filteredChildren}</Box>;
};

Transition.Default = ({
  children,
}: {
  children: React.ReactElement | React.ReactElement[];
}) => {
  return <Box>{children}</Box>;
};

Transition.Translate = ({
  children,
}: {
  children: React.ReactElement | React.ReactElement[];
}) => {
  return <Box>{children}</Box>;
};

export default Transition;
